"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Checkbox = void 0;
const react_1 = __importDefault(require("react"));
const clsx_1 = __importDefault(require("clsx"));
const Checkbox_1 = __importDefault(require("@material-ui/core/Checkbox"));
const CheckBoxSharp_1 = __importDefault(require("@material-ui/icons/CheckBoxSharp"));
const CheckBoxOutlineBlankSharp_1 = __importDefault(require("@material-ui/icons/CheckBoxOutlineBlankSharp"));
const IndeterminateCheckBoxSharp_1 = __importDefault(require("@material-ui/icons/IndeterminateCheckBoxSharp"));
const event_callback_hook_1 = require("../../utils/event-callback-hook");
const checkbox_styles_1 = require("./checkbox-styles");
function Checkbox({ form, value, onChange, disabled, threeState, icon: defaultIcon, checkedIcon: defaultCheckedIcon, highlighted = true, }) {
    // fix undefined value
    value = value !== null && value !== void 0 ? value : null;
    // prepare value for MUI component
    const indeterminate = threeState ? value === null : false;
    value = !!value;
    const handleChange = event_callback_hook_1.useEventCallback((e) => {
        onChange(e.target.checked);
    });
    const handleClick = event_callback_hook_1.useEventCallback((e) => {
        e.stopPropagation();
    });
    const { root, highlightedIcon, ...classes } = checkbox_styles_1.useStyles();
    const icon = defaultIcon || (react_1.default.createElement(CheckBoxOutlineBlankSharp_1.default, { className: clsx_1.default({ [highlightedIcon]: !disabled && highlighted }) }));
    const checkedIcon = defaultCheckedIcon || (react_1.default.createElement(CheckBoxSharp_1.default, { className: clsx_1.default({ [highlightedIcon]: !disabled && highlighted }) }));
    return (react_1.default.createElement(Checkbox_1.default, { classes: {
            root,
            ...classes,
        }, inputProps: {
            form,
        }, indeterminate: indeterminate, disabled: disabled, checked: value, color: "primary", onChange: handleChange, onClick: handleClick, icon: icon, checkedIcon: checkedIcon, indeterminateIcon: react_1.default.createElement(IndeterminateCheckBoxSharp_1.default, null) }));
}
exports.Checkbox = Checkbox;
//# sourceMappingURL=checkbox.js.map